import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';


export interface ImprintContentProps {
}

export default class ImprintContent extends React.Component<ImprintContentProps, any> {
  public render() {
    return(
      <div>
        <div className="row m-0">
          <div className="content-wrap">
            <div className="mb-4">
              <LogoCentered />
            </div>

            <div className="row m-0">
              <div className="col-12 col-md-12">
                <h5 className="d-block mx-auto mb-5 border-bottom pb-2">Impressum</h5>
              </div>
              <div className="col-12 col-md-6">
                <h5>Anschrift</h5>
                <ul className="list-unstyled">
                  <li>KWC Aquarotter GmbH</li>
                  <li>Parkstraße 1-5</li>
                  <li>D-14974 Ludwigsfelde</li>
                  <li>Telefon 03378 818-0</li>
                  <li>Telefax 03378 818-100</li>
                  <li>E-Mail: kwc-info.de@kwc.com</li>
                </ul>
                <ul className="list-unstyled">
                  <li>Amtsgericht Potsdam HRB 27513P</li>
                  <li>UST-ID: DE 121294885</li>
                  <li>St.-Nr. 050/112/04335</li>
                </ul>
                <h5>Geschäftsführer:</h5>
                <ul className="list-unstyled">
                  <li>Marten van der Mei</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}